<template>
  <Layout class="index">
    <navigation />
    <Layout>
      <Content>
        <router-view></router-view>
      </Content>
    </Layout>
  </Layout>
</template>

<script>
import navigation from "@/components/common/navigation.vue";

export default {
  name: "index",
  components: {
    navigation,
  },
};
</script>
<style lang="scss">
.index {
  .left-nav {
    background: unset;
  }
}
.home,
.match {
  .ivu-card-shadow {
    box-shadow: 3px 3px 3px 0 rgba(0, 0, 0, 0.1);
    .ivu-card-body {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/onlyHeader.vue